import ChapterContainer from './ChapterContainer';

export default ChapterContainer;
